import { Text } from '../../../shared/ui/Text/Text';
import { mapPin } from '../../../shared/assets/svg/mapPin';
import { Link } from 'react-router-dom';
import { Stack } from '../../../shared/ui/Stack/Stack';
import styles from './Contact.module.scss';
import Maps from '../../../feature/Map/Maps';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { callIcon } from '../../../shared/assets/svg/callIcon';
import { telegramIcon } from '../../../shared/assets/svg/telegramIcon';


gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 



const Contact = () => {

    useGSAP(() => {
        gsap.fromTo(".contact__title", {"--opacity": 0,  "--x1": "-30px",  "--x2": "30px", opacity:0}, 
                                    {"--opacity": 1, opacity:1, "--x1": "0px",  "--x2": "0px",  
                                    duration: 3, 
        });
        gsap.fromTo(".footer__phone", {opacity: 0, }, {opacity: 1,
            duration: 3, 
            delay:1,
            scrollTrigger: {
            trigger: ".footer__phone"
        }});
        gsap.fromTo(".footer__wapp", {opacity: 0, }, {opacity: 1,
            duration: 3, 
            delay:2,
            scrollTrigger: {
            trigger: ".footer__wapp"
        }});

    }, [])

    return ( 
        <section>
            <Stack                         
                justifyContent = 'justifyCenter' 
                alignItems = 'alignCenter'                         
                className={styles.container}                  
            >
                <Text size='xxl' className={`contact__title ${styles.title}`}>
                    запишитесь на консультацию удобным для вас способом
                </Text>    
            </Stack>

            <div  className={styles.dark}>            
                <div>                   
                    <div className={styles.card__row}> 
                        <Stack
                            direction = 'column'
                            gap = '8'
                            justifyContent = 'justifyBetween'
                            alignItems = 'alignCenter'
                            className={styles.infoCard}>      
                            <Stack 
                                direction = 'column'
                                gap = '8'
                                justifyContent = 'justifyBetween'
                                alignItems = 'alignCenter'
                                className={styles.address}>

                                    <div className={styles.mapIcon}>
                                        {mapPin()}
                                    </div>
                                <Text size='m'className={styles.data}>
                                    350072, Российская Федерация, <br/>Краснодарский край, <br/>город Краснодар, <br/>улица им. Сергея Есенина, <br/>дом №133
                                </Text>
                            </Stack>
                            <Stack 
                                direction = 'column'
                                gap = '8'
                                justifyContent = 'justifyBetween'
                                alignItems = 'alignCenter'
                                className={styles.address}>

                                <Text size='m'className={styles.work}>
                                    РЕЖИМ РАБОТЫ
                                </Text>
                                <Text size='m'className={styles.dataWork}>
                                        Понедельник-пятница с 9:00 до 20:00<br/>
                                        Суббота с 9:00 до 15:00 <br/>
                                        Воскресенье - выходной
                                </Text>
                                <Link to='tel:+79288408020' className={styles.phoneWork}>
                                        +7 928 840 80 20
                                </Link>
                            </Stack>                    
                        </Stack> 

                    <Maps/>
                    </div>
                    <Stack                         
                        justifyContent = 'justifyCenter' 
                        alignItems = 'alignCenter' 
                        className={styles.icons}                        
                    >
                        <Link to='tel:+79288408020' className={`footer__phone ${styles.phone}`}>                        
                            {callIcon()} 
                        </Link> 
                        <Link to="https://t.me/+79288408020" target='_blank' className={`footer__wapp ${styles.phone}`}>
                            {telegramIcon()} 
                        </Link>  
                    </Stack>
                </div>
            </div>
        </section>
    );
}

export default Contact;